/* Tysk katalog for locale-autopilot-sales.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'ap.agent.sales.title': 'Rechnungen und Angebote',
  'ap.agent.sales.pending': '{{count}} Dokumente wurden nicht gesendet.',
  'ap.agent.sales.detail': 'Sende fertige Rechnungen und Angebote. Entwürfe müssen in der Rechnungsliste fertiggestellt werden.',
  'ap.agent.sales.draft': 'Entwurf',
  'ap.agent.sales.invoices': 'Rechnungen',
  'ap.agent.sales.drafts': 'Entwürfe',
  'ap.agent.sales.offers': 'Angebote',
  'ap.agent.offer.sendSelected': '{{count}} ausgewählte Angebote senden',
  'ap.agent.sales.sentCount': '{{count}} Angebote gesendet',
  'ap.agent.sales.send': 'Senden',
  'ap.agent.sales.open': 'Öffnen',
  'ap.agent.sales.empty': 'Keine ungesendeten Dokumente in dieser Liste.',
  'ap.agent.sales.unavailable': 'Das Dokument kann nicht gesendet werden. Öffne die Rechnungsliste, um den Status zu prüfen.',
  'ap.agent.sales.emailMissing': 'Beim Kunden fehlt die E-Mail-Adresse. Füge sie vor dem Senden in der Rechnungsliste hinzu.',
  'ap.agent.sales.sendFailed': 'Das Dokument wurde nicht gesendet. Versuche es erneut über die Rechnungsliste.',
});
